import React from 'react';
import connectPlayer from 'player/connectPlayer';
import Alert from 'common/Alert';
import { AlertPlacement } from 'enums';
import { isEmpty } from 'lib/util';
import { dateFormat } from 'lib/format';

export function getOriginalSizeImageHref(imageHref) {
    if (imageHref) {
        return imageHref.replace(/[wh]=\d*&?/g, '');
    }
    return imageHref;
}

class HeroPlaybackPage extends React.Component {
    render() {
        const { userLocation, alertContent, content } = this.props;
        const displayAlert = !isEmpty(alertContent);
        let displayTime = '';
        if (displayAlert) {
            const { rawDate } = alertContent;
            displayTime = userLocation && userLocation.timeZone ?
                dateFormat.convertDateTime(rawDate, { timeZone: userLocation.timeZone }) :
                dateFormat.dateFormat(rawDate, 'dateTime2');
        }
        const backgroundStyle = Object.keys(content).length > 0 ? {
            backgroundImage: `url(${getOriginalSizeImageHref(content.imageHref)})`,
            backgroundSize: 'cover'
        } : {};
        return (
            <div className="media-wrapper media-wrapper--embed espnplayerwrapper" style={backgroundStyle}>
                <Alert
                    display={displayAlert}
                    displayTime={displayTime}
                    content={alertContent}
                    placement={AlertPlacement.PLAYER}
                />
                <div>
                    <div ref="playerElement" id="watchespn-player-container">&nbsp;</div>
                </div>
            </div>
        );
    }
}

HeroPlaybackPage.propTypes = {
    alertContent: React.PropTypes.object,
    content: React.PropTypes.object,
    userLocation: React.PropTypes.object
};

export default connectPlayer(HeroPlaybackPage);
export { HeroPlaybackPage as BaseHeroPlaybackPage };



// WEBPACK FOOTER //
// ./app/page/hero/HeroPlaybackPage.js